"use client";

import { useState } from "react";

function normalizePhone(value:string,defaultPrefix="+34"){
  const clean=value.trim().replace(/[\s()-]/g,"");
  const match=clean.match(/^(\+\d{1,4})(\d+)$/);
  return match?{prefix:match[1],number:match[2]}:{prefix:defaultPrefix,number:clean.replace(/\D/g,"")};
}

export function ProtectedPhone({phone,prefix="+34",className="phone-button",label="Llamar"}:{phone:string;prefix?:string;className?:string;label?:string}){
  const [visible,setVisible]=useState(false),parsed=normalizePhone(phone,prefix);
  const masked=`${parsed.prefix} ${parsed.number.slice(0,2)}${"•".repeat(Math.max(6,parsed.number.length-2))}`;
  if(visible)return <a className={className} href={`tel:${parsed.prefix}${parsed.number}`}>☎ {label} · {parsed.prefix} {parsed.number}</a>;
  return <button type="button" className={`${className} protected-phone`} onClick={()=>setVisible(true)}>☎ {masked} <b>Ver teléfono</b></button>;
}
